const trigger = document.querySelector('[data-global-menu-trigger]');
const overlay = document.querySelector('#global-menu-overlay');
const closeMenu = () => {
  if (!trigger || !overlay) return;
  trigger.setAttribute('aria-expanded', 'false');
  overlay.setAttribute('aria-hidden', 'true');
  overlay.classList.remove('is-open');
  document.body.classList.remove('global-menu-open');
};

if (trigger && overlay) {
  trigger.addEventListener('click', () => {
    const open = trigger.getAttribute('aria-expanded') !== 'true';
    trigger.setAttribute('aria-expanded', String(open));
    overlay.setAttribute('aria-hidden', String(!open));
    overlay.classList.toggle('is-open', open);
    document.body.classList.toggle('global-menu-open', open);
  });
  overlay.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
  addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMenu();
  });
}

fetch('/api/site-content')
  .then((response) => response.ok ? response.json() : null)
  .then((payload) => {
    const menu = payload?.content?.menu || payload?.menu;
    if (!menu) return;
    const availability = document.querySelector('[data-global-menu-availability]');
    if (availability && menu.availability) availability.textContent = menu.availability;
    const disciplines = document.querySelector('[data-global-menu-disciplines]');
    if (disciplines && menu.disciplines) disciplines.textContent = menu.disciplines;
    ['instagram','vimeo','arena'].forEach((network) => {
      const link = document.querySelector(`[data-global-menu-social="${network}"]`);
      const url = menu[`${network}Url`];
      const label = menu[`${network}Label`];
      if (!link) return;
      if (label) link.textContent = `${label} ↗`;
      link.href = url || '#';
      if (url && url !== '#') {
        link.target = '_blank';
        link.rel = 'noreferrer';
      }
    });
  })
  .catch(() => {});
